import React, { Component } from 'react';
import { Row, Col, Card, Button, Modal, Form, Badge } from 'react-bootstrap';
import { AgGridReact } from 'ag-grid-react';
import axios from 'axios';

import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import "flag-icons/css/flag-icons.min.css";
import '../components/leads.css';
import * as consts from '../consts';

import SplitPane from 'split-pane-react';
import 'split-pane-react/esm/themes/default.css';
const appInfo = require("../../package.json");

const MSG_UNLOCK_LEADS = 'Please upgrade to Premium plan to unmask the lead';

const defaultColDef = {
    filter: true,
    sortable: true,
    resizable: true,
    enableRowGroup: true,
    menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
    filterParams: {
      buttons: ["reset"],
      closeOnApply: true,
    },
    // getMainMenuItems: (params) => {
    //   return [
    //     'sortAsc',
    //     'sortDesc',
    //     'separator',
    //     'copy',
    //     'separator',
    //     'pinSubMenu',
    //   ]}
};

const autoGroupColumnDef = {
  pinned: 'left', // Pin the group column to the left
}

const defaultSideBar = {
  toolPanels: [
    {
      id: 'filters',
      labelDefault: 'Filters',
      labelKey: 'filters',
      iconKey: 'filter',
      toolPanel: 'agFiltersToolPanel',
      toolPanelParams: {
        suppressExpandAll: true,
        suppressFilterSearch: true,
      }
    },
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'column',
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        suppressExpandAll: true,
        suppressFilterSearch: true,
      },
    },
  ],
};
const rowSelection = 'single';
const rowGroupPanelShow = 'onlyWhenGrouping';

const rowModelType = 'serverSide';
const cacheBlockSize = 100;

const pastelBackgrounds = ['#008FFB','#00E396','#FEB019','#FF4560','#775DD0','#3f51b5','#03a9f4','#4caf50','#f9ce1d','#FF9800','#A300D6','#7D02EB','#5653FE','#2983FF','#00B1F2'];

class MLeads extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isCategoryGroup: true,
            isGridView: false,
            gridApi: null,
            rowData: [],
            columnDefs: [],
            selectedData: [],
            selectedUtld: '',
            updatingRowData: false,
            gsplit: [`0%`, 'auto'],
            cards: [],
            selectedCard: 0,
            lastVisibleCard: 0,
            filterMode: 0,
            filterKeys: [],
            loggedInUserId:0,
            clipTip: '',
            clipTipPos: {x:0, y:0},
            showClipTip: false,
            prevResponse: null,
            emailonlycredits:0,
            allleadcredits:0,
            presentcredits:0,
            allleadscount:0,
            emailleadscount:0,
            emailidexportUnitPrice:0,
            fullleadexportUnitPrice:0
      ,showexportmodal:false,
      selectedExportType: '',
        }

        this.onGridReady = this.onGridReady.bind(this);
        this.getRows = this.getRows.bind(this);
        this.getChildCount = this.getChildCount.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.blockFetchData = this.blockFetchData.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.onModelUpdated = this.onModelUpdated.bind(this);
        this.onFirstDataRendered = this.onFirstDataRendered.bind(this);
        this.groupCountComparator = this.groupCountComparator.bind(this);
        this.onStoreRefreshed = this.onStoreRefreshed.bind(this);
        this.checkRenderer = this.checkRenderer.bind(this);
        this.flagRenderer = this.flagRenderer.bind(this);
        this.tldRenderer = this.tldRenderer.bind(this);
        this.urlRenderer = this.urlRenderer.bind(this);
        this.intRenderer = this.intRenderer.bind(this);
        this.floatRenderer = this.floatRenderer.bind(this);
        this.maskRenderer = this.maskRenderer.bind(this);
        this.toggleGroup = this.toggleGroup.bind(this);
        this.toggleView = this.toggleView.bind(this);
        this.refreshCards = this.refreshCards.bind(this);
        this.cardSelectionChanged = this.cardSelectionChanged.bind(this);
        this.onFilterChanged = this.onFilterChanged.bind(this);
        this.applyFilterModel = this.applyFilterModel.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.removeFilter = this.removeFilter.bind(this);
        this.handleCardsScroll = this.handleCardsScroll.bind(this);
        this.copyHeaders = this.copyHeaders.bind(this);
        this.copyClick = this.copyClick.bind(this);
        this.copyData = this.copyData.bind(this);
        this.copyDataAll = this.copyDataAll.bind(this);
        this.clickTimeout = React.createRef();
        this.gridRef=React.createRef();
        this.paramRef=React.createRef();
        this.loggedInUserId=props.loggedInUserId;
        this.popClipTip = this.popClipTip.bind(this);
        this.agRequestRef=React.createRef();
        this.exportmleads=this.exportmleads.bind(this);
        this.exportLeads = this.exportLeads.bind(this);
        this.selectedExportType = '';
      this.closeExportModal = this.closeExportModal.bind(this);
      this.onSelectExportType = this.onSelectExportType.bind(this);
    };

    closeExportModal(){
      this.setState({showexportmodal:false, selectedExportType: ''})
    }

    onSelectExportType(e){
      this.setState({selectedExportType: e.target.value});
    }

    handleCardsScroll(e) {
      const cardsList = e.currentTarget;
      const top = (cardsList.scrollTop === 0);
      const bottom = (Math.abs(cardsList.scrollHeight - (cardsList.scrollTop + cardsList.clientHeight)) <= 5);
      if (top) {
        // this.state.gridApi?.ensureIndexVisible(0, 'top')
      } else if (bottom) {
        const index = this.state.cards.length;
        this.state.gridApi?.ensureIndexVisible(index, 'bottom');
        const lastVisibleIndex = Math.max(0, index - 1);
        const lastVisibleCard = this.state.cards[lastVisibleIndex].id;
        this.setState({ lastVisibleCard: lastVisibleCard });
      } else {
        this.setState({ lastVisibleCard: 0 });
      }
    }

    checkRenderer (params) {
      return (<div className='d-flex justify-content-center'><i className={`${(params.value === '') ? '' : 'bi bi-file-check'}`}></i></div>)
    };

    flagRenderer (params) {
      return ((params.value && params.value !== '') ? <div title={params.data ? params.data.countryname : ''} className={`fi fi-${params.value.toLowerCase()}`}></div> : '')
    }

    tldRenderer (params) {
      return ((params.value && params.value !== '') ? (
        (params.data ? params.data.maskedrow : params.maskedrow) ? (
          <p className="text-blur" onClick={() => alert(MSG_UNLOCK_LEADS)}>{params.value}</p>
        ) : (
          <a rel="noreferrer" target='_blank' href={`https://${params.value}`}>{params.value}</a>
        )
      ) : '' )
    }

    urlRenderer (params) {
      return ((params.value && params.value !== '') ? (
        (params.data ? params.data.maskedrow : params.maskedrow) ? (
          <div className='d-flex justify-content-center mx-1'>
            <i title={params.title} className={`${params.icon}`} onClick={() => alert(MSG_UNLOCK_LEADS)}></i>
          </div> 
        ) : (
          <div className='d-flex justify-content-center mx-1'>
            <a rel="noreferrer" target='_blank' href={`${params.value}`}><i title={params.title} className={`${params.icon}`}></i></a>
          </div> 
        ) 
        ) : '' )
    }

    intRenderer (params) {
      return ((params.value && params.value !== '') ? <span>{parseInt(params.value).toLocaleString()}</span> : '')
    }

    floatRenderer (params) {
      return ((params.value && params.value !== '') ? <span>{parseFloat(params.value).toFixed(1).toLocaleString()}</span> : '')
    }

    maskRenderer (params) {
      return (<span className={(params.data && params.data.maskedrow) ? 'text-blur' : ''}>{params.value}</span>)
    }

    blockFetchData (blockFetch) {
      this.setState({ updatingRowData: blockFetch });
      this.props.urd(blockFetch);
    }

    fetchData = async() => {
      this.state.gridApi?.refreshServerSide({purge: true});
    }

    // Custom comparator function to sort groups by group counts
    groupCountComparator(valueA, valueB, nodeA, nodeB, isInverted) {
      // Get the group counts for the two groups
      const countA = nodeA ? nodeA.allChildrenCount : valueA; // Number of children in group A
      const countB = nodeB ? nodeB.allChildrenCount : valueB; // Number of children in group B

      // Compare the counts and return the result
      if (countA < countB) {
        return -1;
      } else if (countA > countB) {
        return 1;
      } else {
        return 0;
      }
    }

    onGridReady(params) {
        this.setState({
          gridApi: params.api,
        })
        params.api.setServerSideDatasource({getRows: this.getRows});
    }

    getRows(params) {
      if (this.state.updatingRowData) {
        if (this.state.prevResponse) {
          params.successCallback(this.state.prevResponse.rows, this.state.prevResponse.lastRow);
          this.props.rcu(this.state.prevResponse.totals.Totals);
        }
        return;
      }

      const serverURL = `/api/getagmegaleads/`;
      const loggedInUserPlan = this.props.loggedInUserPlan;
      const selectedCategory = ''; // this.props.selectedOnly ? this.props.catalog?.category_en ?? '' : '';
      const selectedState = ''; // this.props.selectedOnly ? this.props.catalog?.state ?? '' : '';
      const isUserCategoryGroup = this.props.isucg;
      const filterCategoryGroup = this.props.categorygroup?.value ?? '';
      const filterMultipleCategories = this.props.multipleCategories ?? '';
      const filterCategory = this.props.category ?? '';
      const filterCountry = this.props.country ?? '';
      const filterState = `'${this.props.state ?? ''}'`;
      const filterKeywords = this.props.kw ?? '';

      this.paramRef.current = params;
      this.agRequestRef.current=params.request;

      this.setState({ updatingRowData: true });
      this.props.urd(true);
      fetch(serverURL, {
        method: 'post',
        body: JSON.stringify({ ...params.request, loggedInUserPlan,loggedInUserId:this.loggedInUserId, selectedCategory, selectedState, isUserCategoryGroup, filterCategoryGroup, filterMultipleCategories, filterCategory, filterCountry, filterState, filterKeywords}),
        headers: { "Content-Type": "application/json; charset=utf-8",Authorization: `Bearer ${sessionStorage.getItem('jwttoken')}` }
      })
      .then(httpResponse => {
        if(httpResponse.status === 429|| httpResponse.status===403) {
           const remainingseconds = httpResponse.headers.get('ratelimit-reset');
           this.props.triggerCaptcha(remainingseconds, 'leads');
        }
        return httpResponse.json()
      })
      .then(response => {
        if(response?.rows){
          this.setState({prevResponse: response});
          if(response?.appversion && response?.appversion!==appInfo.version){
            window.location.reload()
          }
          params.successCallback(response?.rows, response?.lastRow);
          this.props.rcu(response?.totals?.Totals);
          this.refreshCards();
        }
        this.setState({ updatingRowData: false });
        this.props.urd(false);
      })
      .catch(error => {
        console.error(error);
        this.setState({prevResponse: null});
        params.failCallback();
        this.setState({ updatingRowData: false });
        this.props.urd(false);
      })
    }

    getChildCount(data) {
      return data ? data.childCount : undefined
    }
    
    onSelectionChanged() {
      if (this.state.isGridView) {
        const data = this.state.gridApi.getSelectedRows();
        this.setState({
            selectedData: data,
            selectedUtld: data.utld
        })
        this.props.data(data);
      }
    }

    onModelUpdated = (params) => {
      // this.setState({ updatingRowData: false }); console.log('onModelUpdated')
      // this.props.urd(false);
      // this.refreshCards();
    }

    onStoreRefreshed = (params) => {
      // this.setState({ updatingRowData: false }); console.log('onStoreRefreshed')
      // this.props.urd(false);
    }

  onFirstDataRendered = (params) => {
    var cols = [
      { field: 'id', headerName: 'ID', width: 100, hide: true, filter: 'agNumberColumnFilter', pinned: 'left'},
      { field: 'category_en', headerName: 'Category', filter: false, pinned: 'left'},
      { field: 'trimmedname', headerName: 'Name', filter: 'agTextColumnFilter', pinned: 'left', cellRenderer: this.maskRenderer},
      { field: 'tld', headerName: 'Website', filter: 'agTextColumnFilter', cellRenderer: this.tldRenderer },
      { field: 'fulladdress', headerName: 'Address', filter: 'agTextColumnFilter', cellRenderer: this.maskRenderer },
      { field: 'phone', headerName: 'Phone', filter: 'agTextColumnFilter', cellRenderer: this.maskRenderer },
      { field: 'city', headerName: 'City', filter: 'agTextColumnFilter'},
      { field: 'state', headerName: 'State/Territory', filter: false, width: 75, cellStyle: {textAlign: 'center'}},
      { field: 'postalcode', headerName: 'Postal Code', filter: 'agTextColumnFilter', width: 130, cellStyle: {textAlign: 'center'}},
      { field: 'country', headerName: 'Country', filter: 'agTextColumnFilter', width: 100, cellStyle: {textAlign: 'center'}, cellRenderer: this.flagRenderer },
      { field: 'marketpresence', headerName: 'Market Presence', filter: 'agSetColumnFilter', width: 150, cellStyle: {textAlign: 'center'}, filterParams: {values: ["High", "Medium", "Low", "None"]} },
      { field: 'marketreputation', headerName: 'Market Reputation', filter: 'agSetColumnFilter', width: 150, cellStyle: {textAlign: 'center'}, filterParams: {values: ["High", "Medium", "Low", "None"]} },
      { field: 'categories', headerName: 'Categories', filter: 'agTextColumnFilter', hide: true},
      { field: 'contacturl', headerName: 'Contact Page', filter: 'agTextColumnFilter', width: 120, cellRenderer: this.urlRenderer, cellRendererParams: { icon: 'bi bi-card-heading', title: 'Contact Page' } },
      { field: 'abouturl', headerName: 'About Page', filter: 'agTextColumnFilter', width: 120, cellRenderer: this.urlRenderer, cellRendererParams: { icon: 'bi bi-buildings', title: 'About Page' } },
      { field: 'leadershipurl', headerName: 'Team Page', filter: 'agTextColumnFilter', width: 100, cellRenderer: this.urlRenderer, cellRendererParams: { icon: 'bi bi-people-fill', title: 'Team Page' } },
      { field: 'careersurl', headerName: 'Careers Page', filter: 'agTextColumnFilter', width: 120, cellRenderer: this.urlRenderer, cellRendererParams: { icon: 'bi bi-person-workspace', title: 'Careers Page' } },
      { field: 'investorurl', headerName: 'Investor Page', filter: 'agTextColumnFilter', hide: true, width: 120, cellRenderer: this.urlRenderer, cellRendererParams: { icon: 'bi bi-bank', title: 'Investor Page' } },
      { field: 'producturl', headerName: 'Products Page', filter: 'agTextColumnFilter', hide: true, width: 120, cellRenderer: this.urlRenderer, cellRendererParams: { icon: 'bi bi-boxes', title: 'Products Page' } },
      { field: 'isformonsite', headerName: 'Contact Form', filter: 'agTextColumnFilter', width: 130, cellStyle: { textAlign: 'center' }, cellRenderer: this.checkRenderer },
      { field: 'isformwocaptcha', headerName: 'Form w/o Captcha', filter: 'agTextColumnFilter', width: 130, cellStyle: { textAlign: 'center' }, cellRenderer: this.checkRenderer },
      { field: 'carturl', headerName: 'Shopping Cart', filter: 'agTextColumnFilter', width: 120, cellStyle: {textAlign: 'center'}, cellRenderer: this.checkRenderer },
      { field: 'mobileapps', headerName: 'Mobile App', filter: 'agTextColumnFilter', width: 120, cellStyle: {textAlign: 'center'}, cellRenderer: this.checkRenderer },
      { field: 'linkedinurl', headerName: 'LinkedIn', filter: 'agTextColumnFilter', width: 100, cellRenderer: this.urlRenderer, cellRendererParams: { icon: 'bi bi-linkedin', title: 'LinkedIn' } },
      { field: 'facebookurl', headerName: 'Facebook', filter: 'agTextColumnFilter', width: 100, cellRenderer: this.urlRenderer, cellRendererParams: { icon: 'bi bi-facebook', title: 'Facebook' } },
      { field: 'twitterurl', headerName: 'Twitter', filter: 'agTextColumnFilter', width: 100, cellRenderer: this.urlRenderer, cellRendererParams: { icon: 'bi bi-twitter-x', title: 'Twitter' } },
      { field: 'instagramurl', headerName: 'Instagram', filter: 'agTextColumnFilter', width: 100, cellRenderer: this.urlRenderer, cellRendererParams: { icon: 'bi bi-instagram', title: 'Instagram' } },
      { field: 'youtubeurl', headerName: 'Youtube', filter: 'agTextColumnFilter', width: 100, cellRenderer: this.urlRenderer, cellRendererParams: { icon: 'bi bi-youtube', title: 'YouTube' } },
      { field: 'pinteresturl', headerName: 'Pinterest', filter: 'agTextColumnFilter', width: 100, cellRenderer: this.urlRenderer, cellRendererParams: { icon: 'bi bi-pinterest', title: 'Pinterest' } },
      { field: 'whatsappurl', headerName: 'Whatsapp', filter: 'agTextColumnFilter', width: 100, cellRenderer: this.urlRenderer, cellRendererParams: { icon: 'bi bi-whatsapp', title: 'WhatsApp' } },
      { field: 'isemail', headerName: 'Email Present', width: 100, hide: true, filter: 'agNumberColumnFilter'},
      { field: 'ispeople', headerName: 'People Present', width: 100, hide: true, filter: 'agNumberColumnFilter'},
      { field: 'avgwrating', headerName: 'Rating', filter: 'agNumberColumnFilter', width: 80, cellStyle: {textAlign: 'center'}, cellRenderer: this.floatRenderer },
      { field: 'totalreviews', headerName: '#Reviews', filter: 'agNumberColumnFilter', width: 100, hide: true, cellStyle: {textAlign: 'center'}, cellRenderer: this.intRenderer },
      { field: 'branchcount', headerName: '#Branches', filter: 'agNumberColumnFilter', width: 100, hide: true, cellStyle: {textAlign: 'center'}, cellRenderer: this.intRenderer },
      { field: 'addresscount', headerName: '#Addresses', filter: 'agNumberColumnFilter', width: 100, hide: true, cellStyle: {textAlign: 'center'}, cellRenderer: this.intRenderer },
      { field: 'phonecount', headerName: '#Phones', filter: 'agNumberColumnFilter', width: 100, hide: true, cellStyle: {textAlign: 'center'}, cellRenderer: this.intRenderer },
      { field: 'emailcount', headerName: '#Emails', filter: 'agNumberColumnFilter', width: 100, hide: true, cellStyle: {textAlign: 'center'}, cellRenderer: this.intRenderer },
      { field: 'peoplecount', headerName: '#People', filter: 'agNumberColumnFilter', width: 100, hide: true, cellStyle: {textAlign: 'center'}, cellRenderer: this.intRenderer },
    ];
    this.setState({ columnDefs: cols })

    setTimeout(() => {
      const leadsGridInitialState = {
        columnDefs: cols,
        columnState: params.columnApi.getColumnState(),
        groupState: params.columnApi.getColumnGroupState?.(),
      }; 
      this.props.pligs(leadsGridInitialState);
    }, 100)
  }

  toggleGroup(currentGroup) {
    this.setState({isCategoryGroup: currentGroup});
    this.refreshCards();
  } 

  toggleView(currentView) {
    this.setState({
      isGridView: currentView,
      gsplit: currentView ? ["100%", 'auto'] : ["0%", 'auto']
    })
    this.refreshCards();
  }

  refreshCards() {
    var cards = [];
    this.state.gridApi && this.state.gridApi.forEachNode((node, index) => {if ((!node.group) && (node.data)) cards.push(node.data)});
      this.setState({cards: cards});
      this.props.data([]);
    
    if (cards.length > 0) { 
      const selCard = Math.max(cards.findIndex(row => (row.utld === this.state.selectedUtld)), 0);
      const selData = cards[selCard];
      this.setState({
        selectedCard: selCard,
        selectedData: selData,
        selectedUtld: selData.utld
      });
      this.props.data([selData]);
    }

    setTimeout(() => {
      const card = document.getElementById(`lead-${this.state.lastVisibleCard}`);
      card?.scrollIntoView(false);
    }, 50)
  }
    
  cardSelectionChanged(rowid) {
    
    const data = this.state.cards[rowid];
    this.setState({
      selectedData: data,
      selectedUtld: data.utld,
      selectedCard: rowid,
      lastVisibleCard: rowid,
    })
    this.props.data([data]);
    
  }

  onFilterChanged() {
    const currentFilterModel = this.state.gridApi && this.state.gridApi.getFilterModel();
    const filterKeys = Object.keys(currentFilterModel);
    this.setState({filterKeys: filterKeys});
    this.props.lfu(currentFilterModel);
  }

  applyFilterModel(filterValues) {
    this.state.gridApi && this.state.gridApi.setFilterModel(filterValues);
    this.refreshCards();
  }

  applyFilter(filter) {
    let filterModel = this.state.gridApi && this.state.gridApi.getFilterModel();
    let filterKey = '';
    const mode = parseInt(filter.mode + filter.index);
    const value = filter.value; 

    if (mode === 0) {
      filterModel = {}
    } else if (mode === 1) {
      // filterModel = {isprimary: {values: ["true"], filterType: "set"}}
    } else if (mode === 2) {
      // filterModel['isprimary'] = {values: ["true"], filterType: "set"}
    } else if (mode === 3) {
      // filterModel['isprimary'] = {}
    } else if (mode === 4) {
      filterKey = 'fulladdress';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 5) {
      filterKey = 'phone';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 6) {
      filterKey = 'tld';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 10) {
      filterKey = 'isformonsite';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 11) {
      filterKey = 'isformwocaptcha';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 12) {
      filterKey = 'contacturl';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 13) {
      filterKey = 'abouturl';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 14) {
      filterKey = 'leadershipurl';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 15) {
      filterKey = 'careersurl';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 16) {
      filterKey = 'investorurl';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 17) {
      filterKey = 'producturl';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 18) {
      filterKey = 'carturl';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 19) {
      filterKey = 'mobileapps';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 20) {
      filterKey = 'facebookurl';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 21) {
      filterKey = 'twitterurl'
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 22) {
      filterKey = 'instagramurl';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 23) {
      filterKey = 'linkedinurl';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 24) {
      filterKey = 'youtubeurl';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 25) {
      filterKey = 'pinteresturl';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 26) {
      filterKey = 'whatsappurl';
      filterModel[filterKey] = {type: 'notBlank', filter: ''}
    } else if (mode === 91) {
      filterKey = 'marketpresence';
      filterModel[filterKey] = {values: [value], filterType: "set"}
    } else if (mode === 92) {
      filterKey = 'marketreputation';
      filterModel[filterKey] = {values: [value], filterType: "set"}
    } else if (mode === 98) {
      filterKey = 'category_en';
      filterModel[filterKey] = {type: 'equals', filter: value}
    } else if (mode === 99) {
      filterKey = 'state';
      filterModel[filterKey] = {type: 'equals', filter: value}
    } 
  
    this.state.gridApi && this.state.gridApi.setFilterModel(filterModel);
    this.refreshCards();
    // if (filterKey !== '') {
    //   this.props.ucv(filterKey, filterModel[filterKey]);
    // }
  }

  removeFilter(e) {
    const filterKey = e.currentTarget.dataset.value;
    let currFilterModel = this.state.gridApi && this.state.gridApi.getFilterModel();
    const { [filterKey]: _, ...filterModel } = currFilterModel;
    // filterModel[filterKey] = {};
    this.state.gridApi && this.state.gridApi.setFilterModel(filterModel);
    if (!this.state.isGridView) this.refreshCards();    
    // this.props.ucv(filterKey, undefined);
  }

  popClipTip(message) {
    this.setState({
      showClipTip: true, 
      clipTip: message
    });

    setTimeout(() => this.setState({showClipTip: false, clipTip: ''}), 500);
  }

  copyHeaders(e) {
    const parent = e.currentTarget.parentElement.parentElement;
    const rect = parent.getBoundingClientRect();
    this.setState({clipTipPos: {x: rect.left + window.scrollX, y: rect.top + window.scrollY}});

    const index = e.currentTarget.dataset.id;
    const row = this.state.cards[index];
    if (row.maskedrow) {
      alert(MSG_UNLOCK_LEADS)
    } else {
      // const peoplecols = ['Person Name','Role','Person Phone','Person Email','Person LinkedIn','Role Level','Role Function'];
      // const leadcols = this.state.columnDefs.map(e => e.headerName);
      // const cols = [...peoplecols, ...leadcols];
      const cols = ['Business-Person ID','Business ID','Primary Category','Business Name','Website','Business Address','Business Phone','Business Emails','Other Phones','Person ID','Person Name','Role','Person Email','Person Phone','Person LinkedIn','Role Level','Role Function','City','State','Postal Code','Country','Market Presence','Market Reputation','Rating','Categories','Contact Page','About Page','Team Page','Careers Page','Investor Page','Products Page','Contact Form','Shopping Cart','Mobile App','LinkedIn','Facebook','Twitter','Instagram','Youtube','Pinterest','WhatsApp','Email Present','People Present','#Branches','#Addresses','#Phones','#Emails','Lead Source','Date Copied','User ID']
      const tsv = cols.join('\t');

      navigator.clipboard.writeText(tsv).then(() => {
        this.popClipTip('Headers copied to Clipboard')
      }).catch(err => {
        this.popClipTip('Error: Could not copy to Clipboard')
      });
    }
  }

  copyClick(e) {
    const parent = e.currentTarget.parentElement.parentElement;
    const rect = parent.getBoundingClientRect();
    this.setState({clipTipPos: {x: rect.left + window.scrollX, y: rect.top + window.scrollY}});

    const index = e.currentTarget.dataset.id;
    const row = this.state.cards[index];

    clearTimeout(this.clickTimeout.current);

    this.clickTimeout.current = setTimeout(() => {
      this.copyData(row)     
    }, 250);
  }

  async copyData(row) {
    if (row.maskedrow) {
      alert(MSG_UNLOCK_LEADS)
    } else {

      const response=await axios.get(`/allowleadcopy/${this.loggedInUserId}`);
      if(!response.data.allowcopy){
        alert(`You have reached your daily copy limit.`);
        return;
      }
      else
      {
        const currentDate = new Date();
        const currentDateFormatted = currentDate.toLocaleDateString();

        const cols = ['leadpersonid','leadid','category_en','companyname','tld','fulladdress','businessphone','businessemails','otherphones','rank','name','role','email','phone','linkedin','levels','functions','city','state','postalcode','country','marketpresence','marketreputation','avgwrating','categories_array','contacturl','abouturl','leadershipurl','careersurl','investorurl','producturl','isformonsite','carturl','mobileapps','linkedinurl','facebookurl','twitterurl','instagramurl','youtubeurl','pinteresturl','whatsappurl','isemail','ispeople','branchcount','addresscount','phonecount','emailcount','leadsource','datecopied','userid'];

        let tempRow = [];
        cols.map(f => tempRow[f] = row[f]);
        tempRow['leadpersonid'] = `${row['id']}-0`;
        tempRow['leadid'] = row['id'];
        tempRow['companyname'] = row['trimmedname'];
        tempRow['businessphone'] = `'${row['phone']}`;
        tempRow['phone'] = '';
        tempRow['businessemails'] = '';
        tempRow['otherphones'] = '';
        tempRow['country'] = this.props.country;
        tempRow['isformonsite'] = row['isformonhp'] && row['isformoncp'];
        tempRow['leadsource'] = 'WowLeads';
        tempRow['datecopied'] = currentDateFormatted;
        tempRow['userid'] = this.props.loggedInUserId;

        const tsv = cols.map(f => String(tempRow[f] ?? '').replace(/[\t\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').trim()).join('\t');

        navigator.clipboard.writeText(tsv).then(async () => {
            this.popClipTip('Business data copied to Clipboard')
            await axios.post('/markcopiedlead', { userid: this.loggedInUserId, leadid: row['id'], ispeople: false });
          }).catch(err => {
            this.popClipTip('Error: Could not copy to Clipboard')
        });
      }
    }
  }

  async copyDataAll(e) {
    clearTimeout(this.clickTimeout.current);

    const parent = e.currentTarget.parentElement.parentElement;
    const rect = parent.getBoundingClientRect();
    this.setState({clipTipPos: {x: rect.left + window.scrollX, y: rect.top + window.scrollY}});

    const index = e.currentTarget.dataset.id;
    const row = this.state.cards[index];
    if (row.maskedrow) {
      alert(MSG_UNLOCK_LEADS)
    } else {

      const response=await axios.get(`/allowleadcopy/${this.loggedInUserId}`);
      if(!response.data.allowcopy){
        alert(`You have reached your daily copy limit.`);
        return;
      }
      else
      {
        const filterCountry = this.props.country ?? '';
        const filterLeadId = row.id;
        const currentDate = new Date();
        const currentDateFormatted = currentDate.toLocaleDateString();

        axios.post('/getmegapeople', { filterCountry, filterLeadId })
        .then(res => {
          // const cols = Object.keys(res.data[0]);
          // const peoplecols = ['name','role','phone','email','linkedin','levels','functions'];
          // const leadcols = this.state.columnDefs.map(e => e.field);
          // const cols = [...peoplecols, ...leadcols];
          const cols = ['leadpersonid','leadid','category_en','companyname','tld','fulladdress','businessphone','businessemails','otherphones','rank','name','role','email','phone','linkedin','levels','functions','city','state','postalcode','country','marketpresence','marketreputation','avgwrating','categories_array','contacturl','abouturl','leadershipurl','careersurl','investorurl','producturl','isformonsite','carturl','mobileapps','linkedinurl','facebookurl','twitterurl','instagramurl','youtubeurl','pinteresturl','whatsappurl','isemail','ispeople','branchcount','addresscount','phonecount','emailcount','leadsource','datecopied','userid'];

          var tsvs = [];
          res.data.forEach(row => {
            let tempRow = [];
            cols.map(f => tempRow[f] = row[f]);
            tempRow['leadpersonid'] = `${row['leadid']}-${row['rank']}`;
            tempRow['businessphone'] = `'${row['businessphone']}`;
            tempRow['phone'] = `'${row['phone']}`;
            tempRow['businessemails'] = '';
            tempRow['otherphones'] = '';
            tempRow['country'] = this.props.country;
            tempRow['isformonsite'] = row['isformonhp'] && row['isformoncp'];
            tempRow['leadsource'] = 'WowLeads';
            tempRow['datecopied'] = currentDateFormatted;
            tempRow['userid'] = this.props.loggedInUserId;
            tsvs.push(cols.map(f => String(tempRow[f] ?? '').replace(/[\t\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').trim()).join('\t'));
          })

          const tsv = tsvs.join('\n');

          navigator.clipboard.writeText(tsv).then(async () => {
            this.popClipTip('Business & People data copied to Clipboard')
            await axios.post('/markcopiedlead', { userid: this.loggedInUserId, leadid: row['id'], ispeople: false });
          }).catch(err => {
            this.popClipTip('Error: Could not copy to Clipboard')
          });
        })
        .catch((error) => {
          console.log(error);
        })
      }
    }
  }

  async exportmleads(includePeople,isFreeLeadsExport){
      const loggedInUserPlan = this.props.loggedInUserPlan;
        // const selectedCategory = this.props.selectedOnly ? this.props.catalog?.category_en ?? '' : '';
        // const selectedState = this.props.selectedOnly ? this.props.catalog?.state ?? '' : '';
        const isUserCategoryGroup = this.props.isucg;
        const filterCategoryGroup = this.props.categorygroup?.value ?? '';
        const filterMultipleCategories = this.props.multipleCategories ?? '';
        const filterCategory = this.props.category ?? '';
        const filterCountry = this.props.country ?? '';
        const filterState = `'${this.props.state ?? ''}'`;
        const filterKeywords = this.props.kw ?? '';

        this.props.setExportingLeadsData(true)
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = `${process.env.REACT_APP_URL}/api/exportagmegaleads`;
        form.style.display = 'none';
        //form.target = '_blank'; // Optional: open in new tab or stream in same tab

        // Add hidden input fields
        const data = {includePeople,...this.agRequestRef.current, loggedInUserPlan,loggedInUserId:this.loggedInUserId, isUserCategoryGroup, filterCategoryGroup, filterMultipleCategories, filterCategory, filterCountry, filterState, filterKeywords, isFreeLeadsExport};

          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'jwttoken';
          input.value = sessionStorage.getItem('jwttoken');
          form.appendChild(input);

          const input1 = document.createElement('input');
          input1.type = 'hidden';
          input1.name = 'json';
          input1.value = JSON.stringify(data);
          form.appendChild(input1);

        document.body.appendChild(form);
        form.submit(); // this will stream the file
        document.body.removeChild(form);
        this.props.setExportingLeadsData(false)
  }

  async getEmailLeadsCount(){
      
      const isUserCategoryGroup = this.props.isucg;
      const filterCategoryGroup = this.props.categorygroup?.value ?? '';
      const filterMultipleCategories = this.props.multipleCategories ?? '';
      const filterCategory = this.props.category ?? '';
      const filterCountry = this.props.country ?? '';
      const filterState = `'${this.props.state ?? ''}'`;
      const filterKeywords = this.props.kw ?? '';
      const includePeople= false;
      const loggedInUserPlan = this.props.loggedInUserPlan;
      const sqlcondition = ' (emailcount>0) '
      const startRow=0;
      const endRow=1;

      const data = {includePeople,...this.agRequestRef.current, loggedInUserPlan,loggedInUserId:this.loggedInUserId, isUserCategoryGroup, filterCategoryGroup, filterMultipleCategories, filterCategory, filterCountry, filterState, filterKeywords, sqlcondition,startRow,endRow};
      const response = await axios.post(`/getagmegaleads`,data)
      return response.data.totals.Totals;
  }
  async exportLeads(includePeople){
      const loggedInUserPlan = this.props.loggedInUserPlan;
      //Checking Plan
      if(loggedInUserPlan.id===consts.FREE_PLAN_ID||loggedInUserPlan.id===consts.ADMIN_PLAN_ID)
      {
        if(loggedInUserPlan.id===consts.FREE_PLAN_ID)
        alert("Only unmaksed rows will be exported. Please subscribe to Premium plan for viewing and exporting all data.")

        await this.exportmleads(includePeople,false)
      }
      else{

        this.props.setExportingLeadsData(true)
        //aquiring required details
        const response=await axios.get(`/pricingbyuser/${this.loggedInUserId}`)
        const pricing=response.data

        const result= await axios.get(`/usercredits/${this.loggedInUserId}`)
        const presentcredits= parseInt(result.data)

        //calculating required credits
        const allleadscount=this.props.leadsResultsCount
        const emailleadscount=await this.getEmailLeadsCount()
        const emailonlycredits=emailleadscount*pricing.emailidexport
        const allleadcredits=allleadscount*pricing.fullleadexport

        this.setState({allleadscount,emailleadscount,emailonlycredits,allleadcredits,presentcredits,emailidexportUnitPrice:pricing.emailidexport,fullleadexportUnitPrice:pricing.fullleadexport})
        this.setState({showexportmodal:true, selectedExportType: 'all'})
        this.props.setExportingLeadsData(false)
      }      
  }

  async handleExportConfirm(exportType){
    this.setState({showexportmodal:false})

    if(window.confirm(`${exportType==='emailonly'? this.state.emailonlycredits: this.state.allleadcredits} credits will be deducted for the selected rows to export`))
    {
      const isUserCategoryGroup = this.props.isucg;
      const filterCategoryGroup = this.props.categorygroup?.value ?? '';
      const filterMultipleCategories = this.props.multipleCategories ?? '';
      const filterCategory = this.props.category ?? '';
      const filterCountry = this.props.country ?? '';
      const filterState = `'${this.props.state ?? ''}'`;
      const filterKeywords = this.props.kw ?? '';
      const includePeople= false;
      const loggedInUserPlan = this.props.loggedInUserPlan;
      const sqlcondition = ' (emailcount>0) '
      const leadcount = exportType==='emailonly' ? this.state.emailleadscount : this.state.allleadscount;
      const unitprice = exportType==='emailonly' ? this.state.emailidexportUnitPrice : this.state.fullleadexportUnitPrice;
      const requiredcredits = exportType==='emailonly' ? this.state.emailonlycredits : this.state.allleadcredits;

      const data = {includePeople,...this.agRequestRef.current, loggedInUserPlan,loggedInUserId:this.loggedInUserId, isUserCategoryGroup, filterCategoryGroup, filterMultipleCategories, filterCategory, filterCountry, filterState, filterKeywords,sqlcondition,leadcount,unitprice,requiredcredits,exportType};
      if(requiredcredits<=this.state.presentcredits)
      {
        axios.post(`/exportleadsintofile`,data)
        .then((result1)=>{
            alert(result1.data)
        })
        .catch(()=>{
            alert('Something went wrong, please try again after some time')
        })   
      }       
    }
  }

  render () {
    const noFooterData = (row) => {return (  
      (row.contacturl === '') && 
      (row.abouturl === '') && 
      (row.leadershipurl === '') &&
      (row.careersurl === '') &&
      (row.investorurl === '') &&
      (row.producturl === '') && 
      (row.linkedinurl === '') &&
      (row.facebookurl === '') &&
      (row.twitterurl === '') &&
      (row.instagramurl === '') &&
      (row.youtubeurl === '') &&
      (row.pinteresturl === '') &&
      (row.whatsappurl === '')
    )}
      
    return (
    <div ref={this.tabRef} className="d-flex flex-column flex-fill h-100">
      <div>
          {this.state.filterKeys.map((key, index) => (
          <Button id={`filterkey-${index}`} data-value={key} size="sm" variant="outline-primary" className='ms-1 rounded' onClick={this.removeFilter}>
            <i class="bi bi-x-circle-fill me-2"></i>{this.state.columnDefs.find(o => o.field === key)?.headerName}
          </Button>
          ))}
      </div>
      <SplitPane split="horizontal" allowResize={false} sizes={this.state.gsplit} resizerSize={5} onChange={(data) => this.setState({gsplit: data})}>
          <div className="ag-theme-balham" style={{height: '100%'}}>
            <AgGridReact 
              columnDefs={this.state.columnDefs}
              defaultColDef={defaultColDef}
              autoGroupColumnDef={autoGroupColumnDef}
              sideBar={defaultSideBar}
              suppressContextMenu={true}
              animateRows={true}
              rowMultiSelectWithClick={false}
              rowSelection={rowSelection}
              rowGroupPanelShow={rowGroupPanelShow}
              onGridReady={this.onGridReady}
              onGridRefresh={this.onGridRefresh}
              onSelectionChanged={this.onSelectionChanged}
              onRowDataUpdated={this.onRowDataUpdated}
              onModelUpdated={this.onModelUpdated}
              onFirstDataRendered={this.onFirstDataRendered}
              onStoreRefreshed={this.onStoreRefreshed}
              onFilterChanged={this.onFilterChanged}
              rowModelType={rowModelType}
              getChildCount={this.getChildCount}
              cacheBlockSize={cacheBlockSize}
              alwaysShowHorizontalScroll={false}
              alwaysShowVerticalScroll={false}
              ref={this.gridRef}
            ></AgGridReact>
          </div>
        {this.state.cards ? (
        <div className="m-2" style={{maxHeight: "99%", display: 'grid', overflowX: 'hidden', overflowY: 'auto', gap: '4px', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))'}} onScroll={this.handleCardsScroll}>
          <div className={`w-100 justify-content-center ${((this.state.updatingRowData) || (this.state.cards.length > 0)) ? 'd-none' : 'd-flex'}`}>
            <p style={{fontFamily: "var(--font-family-sans-serif)"}}>
                There's nothing here, yet.
            </p>
          </div>
          {this.state.cards.map((row, index) => (
          <Col xs={1} key={index} style={{width: '100%', boxSizing: 'border-box'}}>
            <Card 
              id={`lead-${row.id}`}
              key={index}
              title={row.name}
              onClick={() => this.cardSelectionChanged(index)}
              className={`m-1 p-0 text-primary border border-2 ${(index === this.state.selectedCard) ? 'border-primary shadow-lg' : 'shadow'}`} 
            >
              <Card.Header className={`fs-6 text-white p-0 align-items-center`} style={{backgroundColor: `${pastelBackgrounds[index % 15]}`}}>
                <div className="d-flex flex-row">
                  <div className={`p-2 h6 my-auto text-white ${(row.maskedrow) ? 'text-blur' : ''} `}>
                    {row.trimmedname}
                  </div>
                  <div className="ms-auto my-auto">
                    <Button title="Copy to Clipboard" className="border-0 text-white" variant="link" data-id={index} onContextMenu={this.copyHeaders} onClick={this.copyClick} onDoubleClick={this.copyDataAll}><i className="bi bi-copy"></i></Button>
                  </div>
                </div>
              </Card.Header>
              <Card.Body className='px-3 py-2 text-dark business-step2' style={{backgroundColor: `${pastelBackgrounds[index % 15]}22`}}>
                <Card.Text>
                  {(row.fulladdress !== '') ? (
                  <Row className="mb-1">
                    <Col xs={1}><a rel="noreferrer" target='_blank' className={(row.maskedrow) ? 'link-blur' : ''} href={`https://plus.codes/map/${row.latitude},${row.longitude}`}><i class="bi bi-geo-alt"></i></a></Col>
                    <Col className={(row.maskedrow) ? 'text-blur' : ''}>{row.fulladdress}</Col>
                  </Row>
                  ) : ""}
                  {(row.phone !== '') ? (
                  <Row className="mb-2">
                    <Col xs={1}><i class="bi bi-telephone"></i></Col>
                    <Col className={(row.maskedrow) ? 'text-blur' : ''}>{row.phone}</Col>
                  </Row>
                  ) : ''}
                  {(row.tld !== '') ? (
                  <Row className="mb-2">
                    <Col xs={1}><a rel="noreferrer" target='_blank' className={(row.maskedrow) ? 'link-blur' : ''} href={`https://${row.tld}`} disabled={row.isgoodurl?false:true}><i class="bi bi-globe"></i></a></Col>
                    <Col title={row.tld} className={`text-break ${(row.maskedrow) ? 'text-blur' : ''}`}>{row.tld}</Col>
                  </Row>
                  ) : ''}
                  {(row.categories_array !== '') ? (
                  <Row className="mb-2">
                    <Col xs={1}><i class="bi bi-tags"></i></Col>
                    <Col><span className="text-capitalize">{row.categories_array.join(", ")}</span></Col>
                  </Row>
                  ) : ''}
                  <div className="d-flex flex-row">
                    {(row.branchcount > 0) ? (<div title="Branches" className="me-2 p-1 py-auto shadow-sm rounded"><i className="bi bi-buildings"></i><span className="ms-1" style={{verticalAlign: "super"}}>{row.branchcount}</span></div>) : ''}
                    {(row.addresscount > 0) ? (<div title="Addresses" className="me-2 p-1 py-auto shadow-sm rounded"><i className="bi bi-geo-alt"></i><span className="ms-1" style={{verticalAlign: "super"}}>{row.addresscount}</span></div>) : ''}
                    {(row.phonecount > 0) ? (<div title="Phone Numbers" className="me-2 p-1 py-auto shadow-sm rounded"><i className="bi bi-telephone"></i><span className="ms-1" style={{verticalAlign: "super"}}>{row.phonecount}</span></div>) : ''}
                    {(row.emailcount > 0) ? (<div title="Email IDs" className="me-2 p-1 py-auto shadow-sm rounded"><i className="bi bi-envelope"></i><span className="ms-1" style={{verticalAlign: "super"}}>{row.emailcount}</span></div>) : ''}
                    {(row.peoplecount > 0) ? (<div title="People" className="me-2 p-1 py-auto shadow-sm rounded"><i className="bi bi-people"></i><span className="ms-1" style={{verticalAlign: "super"}}>{row.peoplecount}</span></div>) : ''}
                  </div>
                </Card.Text>
              </Card.Body>
              {noFooterData(row) ? '' : (
              <Card.Footer>
                <Card.Text className='m-0 p-0 mt-auto d-flex flex-row flex-wrap' style={{minHeight: "20px"}}>
                  {(row.contacturl === '') ? '' : this.urlRenderer({value: row.contacturl, icon: 'bi bi-card-heading', maskedrow: row.maskedrow, title: 'Contact Page' })}
                  {(row.abouturl === '') ? '' : this.urlRenderer({value: row.abouturl, icon: 'bi bi-buildings', maskedrow: row.maskedrow, title: 'About Page' })}
                  {(row.leadershipurl === '') ? '' : this.urlRenderer({value: row.leadershipurl, icon: 'bi bi-people-fill', maskedrow: row.maskedrow, title: 'Team Page' })}
                  {(row.careersurl === '') ? '' : this.urlRenderer({value: row.careersurl, icon: 'bi bi-person-workspace', maskedrow: row.maskedrow, title: 'Careers Page' })}
                  {(row.investorurl === '') ? '' : this.urlRenderer({value: row.investorurl, icon: 'bi bi-bank', maskedrow: row.maskedrow, title: 'Investor Page' })}
                  {(row.producturl === '') ? '' : this.urlRenderer({value: row.producturl, icon: 'bi bi-boxes', maskedrow: row.maskedrow, title: 'Products Page' })}
                  {(row.linkedinurl === '') ? '' : this.urlRenderer({value: row.linkedinurl, icon: 'bi bi-linkedin', maskedrow: row.maskedrow, title: 'LinkedIn' })}
                  {(row.facebookurl === '') ? '' : this.urlRenderer({value: row.facebookurl, icon: 'bi bi-facebook', maskedrow: row.maskedrow, title: 'Facebook' })}
                  {(row.twitterurl === '') ? '' : this.urlRenderer({value: row.twitterurl, icon: 'bi bi-twitter-x', maskedrow: row.maskedrow, title: 'Twitter' })}
                  {(row.instagramurl === '') ? '' : this.urlRenderer({value: row.instagramurl, icon: 'bi bi-instagram', maskedrow: row.maskedrow, title: 'Instagram' })}
                  {(row.youtubeurl === '') ? '' : this.urlRenderer({value: row.youtubeurl, icon: 'bi bi-youtube', maskedrow: row.maskedrow, title: 'YouTube' })}
                  {(row.pinteresturl === '') ? '' : this.urlRenderer({value: row.pinteresturl, icon: 'bi bi-pinterest', maskedrow: row.maskedrow, title: 'Pinterest' })}
                  {(row.whatsappurl === '') ? '' : this.urlRenderer({value: row.whatsappurl, icon: 'bi bi-whatsapp', maskedrow: row.maskedrow, title: 'WhatsApp' })}
                </Card.Text>
              </Card.Footer>
              )}
            </Card>
          </Col>
            ))}
        </div>
          ) : <></>}
      </SplitPane>
      {this.state.showClipTip && (
        <div className="clip-tip" style={{ top: this.state.clipTipPos.y, left: this.state.clipTipPos.x }}>
          {this.state.clipTip}
        </div>
      )}
      {/* Export selection modal */}
      <Modal show={this.state.showexportmodal} onHide={this.closeExportModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Export Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Check type="radio" id="export-emailonly" name="exportType" className={'fw-bold'} value="emailonly" label={`Email IDs only (${parseInt(this.state.emailleadscount).toLocaleString()} leads) - ${parseInt(this.state.emailonlycredits).toLocaleString()} credits`} onChange={this.onSelectExportType} checked={this.state.selectedExportType==='emailonly'} />
            <div className="mt-2" />
            <Form.Check type="radio" id="export-all" name="exportType" className={'fw-bold'} value="all" label={`All leads (${parseInt(this.state.allleadscount).toLocaleString()} leads) - ${parseInt(this.state.allleadcredits).toLocaleString()} credits`} onChange={this.onSelectExportType} checked={this.state.selectedExportType==='all'} />

            <hr />
            <div className="d-flex justify-content-between align-items-center">
              <div>Present Credits</div>
              <span className='fw-bold'>{this.state.presentcredits}</span>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.closeExportModal}>Cancel</Button>
          <Button variant="primary" onClick={() => this.exportmleads(false,true)} onContextMenu={()=>this.exportmleads(true,true)}>Export Free Leads</Button>
          <Button variant="primary" disabled={!(this.state.selectedExportType && ((this.state.selectedExportType==='emailonly' ? this.state.emailonlycredits : this.state.allleadcredits) <= this.state.presentcredits))} onClick={() => this.handleExportConfirm(this.state.selectedExportType)}>Export</Button>
          {/* <Button variant="primary" onClick={() => this.handleExportConfirm(this.state.selectedExportType)}>Export</Button> */}

        </Modal.Footer>
      </Modal>
    </div>
    )}
}

export default MLeads;